module.exports = __webpack_public_path__ + "img/index_topbg.9ee81024.png";